import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { fetchNavigationOrganizations } from 'register-partners-js/utils/fetch-navigation-organizations';

export default class ResumeAlreadyCreatedRoute extends Route {
  @service networkManager;

  async model({ organization_id: id }) {
    let organizations = await fetchNavigationOrganizations(this.networkManager);
    return organizations.find(org => org.id === id);
  }
}
